import {
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import {useBottomSheet} from 'components/BottomSheet';
import React from 'react';
import OutHook from './out-hook';

// function BottomSheetDrawer({ onExited, ...props }) {
//   return (

//     <Drawer anchor="bottom" {...props}>
//        <Grid style={{...bottomSheetProps?.styleHeader ,display:bottomSheetProps?.styleHeader?'block':'none'}}>
//         <Typography style={{textAlign:'center',color:'#fff',padding:'10px'}}>بارگذاری عکس</Typography>
//        </Grid>
//       <Container style={{ paddingTop: 8 }}>{props.children}</Container>
//     </Drawer>

//   );
// }

const InnerBottomSheetConfigurator = (props) => {
  props.setUseBottomSheetRef(useBottomSheet());
  return null;
};

let useBottomSheetRef;
const setUseBottomSheetRef = (useBottomSheetRefProp) => {
  useBottomSheetRef = useBottomSheetRefProp;
};

export const BottomSheetConfigurator = () => {
  return (
    <InnerBottomSheetConfigurator setUseBottomSheetRef={setUseBottomSheetRef} />
  );
};

function showBottomSheet(children, bottomSheetProps) {
  function BottomSheetDrawer({onExited, ...props}) {
    return (
      <Drawer
        anchor="bottom"
        {...props}
        PaperProps={{
          style: {
            ...props.PaperProps?.style,
            // maxHeight: '90vh',
            height: 'fit-content',
            borderRadius: '24px 24px 0 0',
          },
        }}
      >
        <Grid
          style={{
            ...bottomSheetProps?.styleHeader,
            display: bottomSheetProps?.styleHeader ? 'block' : 'none',
          }}
        >
          <Typography
            style={{textAlign: 'center', color: '#fff', padding: '10px'}}
          >
            بارگذاری عکس
          </Typography>
        </Grid>
        <Container
          style={{
            paddingTop: 8,
            height: 'auto',
            overflow: 'visible',
          }}
        >
          {props.children}
        </Container>
      </Drawer>
    );
  }
  const {dialogTitle, forceBottomSheet, modalProps} = bottomSheetProps || {};
  if (OutHook.useIsDesktop && !forceBottomSheet) {
    const DialogComponent = ({dialogTitle, ...props}) => (
      <Dialog
        maxWidth={10000}
        {...props}
        {...modalProps}
        PaperProps={{
          style: {
            ...props.PaperProps?.style,
            // borderRadius: bottomSheetProps?.instant ? '24px' : '0',
            borderRadius: '24px',
            height: 'fit-content',
          },
        }}
      >
        <Grid
          style={{
            ...bottomSheetProps?.styleHeader,
            display: bottomSheetProps?.styleHeader ? 'block' : 'none',
          }}
        >
          <Typography
            style={{textAlign: 'center', color: '#fff', padding: '10px'}}
          >
            بارگذاری عکس
          </Typography>
        </Grid>

        {/* relate to upload pic roles header for adviser */}

        {dialogTitle && <DialogTitle>{dialogTitle}</DialogTitle>}
        <DialogContent
          style={{
            ...bottomSheetProps?.style,
            minWidth: 350,
            height: 'fit-content',
          }}
        >
          {children}
        </DialogContent>
      </Dialog>
    );
    const {showModal} = OutHook.useModal;
    return showModal(DialogComponent, {dialogTitle});
  }

  const {showBottomSheet} = useBottomSheetRef;
  const Component = (props) => (
    <BottomSheetDrawer {...props} ModalProps={modalProps}>
      {children}
    </BottomSheetDrawer>
  );

  return showBottomSheet(Component);
}

export default showBottomSheet;
